import { SETTING_ADDED, SETTING_SET, SETTING_DELETED, SETTING_EDITED } from 'src/app/redux/redux-types';
import { reduxSettingTypes } from 'src/types';

export const settingDefaultState: reduxSettingTypes.StateType = {
  settingList: [],
};

export const settingReducer = (
  state = settingDefaultState,
  action: reduxSettingTypes.ActionType,
): reduxSettingTypes.StateType => {
  switch (action.type) {
    case SETTING_SET:
      return {
        ...state,
        settingList: action.payload,
      };
    case SETTING_ADDED:
      // eslint-disable-next-line no-case-declarations
      const exists = state.settingList.some((item) => item.id === action.payload.id);
      if (exists) {
        return state;
      }
      return {
        ...state,
        settingList: [action.payload, ...state.settingList],
      };
    case SETTING_EDITED:
      // eslint-disable-next-line no-case-declarations
      const updateIndex = state.settingList.findIndex((obj) => obj.id === action.payload.id);
      return {
        ...state,
        settingList: [
          ...state.settingList.slice(0, updateIndex),
          action.payload,
          ...state.settingList.slice(updateIndex + 1),
        ],
      };
    case SETTING_DELETED:
      return {
        ...state,
        settingList: state.settingList.filter((o) => o.id !== action.payload),
      };
    default:
      return state;
  }
};
